<mat-form-field *ngIf="!formReadonlyMode"
                [formGroup]="form"
                [ngClass]="{'hidden': hidden || disabled}"
                (click)="fileInput.click()"
                class="mxs-input"
                [matTooltip]="getValidationHint() | translate"
                [matTooltipClass]="'mxs-error-ttip'">
    <mat-label>{{getLabel() | translate}}</mat-label>
    <input  matInput
            type="text"
            [errorStateMatcher]=errorService
            [required]="required"
            value="{{fileName || ''}}">
    <input  #fileInput
            type="file"
            class="hidden"
            id="file-input"
            [accept]="types"
            (change)="onFileChange($event.target.files)" />

    <mat-hint>{{getHint() | translate}}</mat-hint>
  <mat-error *ngFor="let error of getValidationMessages(true)">
      {{getError(error) | translate}}
  </mat-error>
</mat-form-field>

<!--In formReadonlyMode display nothing-->
